<template>
  <footer class="app-footer">
    <span class="d-sm-down-none"
      ><a href="javascript:void(0);"
        ><strong>{{ $t('startPage.footerTitle') }}</strong></a
      >
      | Version {{ version }}</span
    >
    <span class="float-right"
      >Powered by
      <a
        href="http://nexum.com.br/"
        target="_blank"
        ><strong>Nexum</strong></a
      ><span v-if="screenW < 768"> | v{{ version }}</span></span
    >
  </footer>
</template>
<script>
export default {
  name: 'footerApp',
  data () {
    return {
      version: process.env.VersionApp,
      screenW: screen.width
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/layout/Footer.vue